import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { withFlowWebContext } from '../FlowWebProvider/withFlowWebContext';
var errorAttributeName = 'data-field-error';
export var FormContext = /*#__PURE__*/React.createContext({
  active: false,
  registerValidator: function registerValidator() {},
  unregisterValidator: function unregisterValidator() {},
  isForm: false
});
export var useFormContext = function useFormContext() {
  return React.useContext(FormContext);
};
export var _FormWithValidation = /*#__PURE__*/function (_React$Component) {
  _inherits(_FormWithValidation, _React$Component);
  var _super = _createSuper(_FormWithValidation);
  function _FormWithValidation() {
    var _this;
    _classCallCheck(this, _FormWithValidation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      forceShowValidation: false,
      active: false
    });
    _defineProperty(_assertThisInitialized(_this), "formRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "fieldValidator", void 0);
    _defineProperty(_assertThisInitialized(_this), "registerValidator", function (validator) {
      _this.fieldValidator = validator;
    });
    _defineProperty(_assertThisInitialized(_this), "unregisterValidator", function () {
      _this.fieldValidator = undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        forceShowValidation: true,
        active: true
      });
      if (_this.fieldValidator) {
        return _this.fieldValidator().then(function () {
          return _this.validate(e);
        })["catch"](function () {
          return _this.setState({
            active: false
          });
        });
      }
      _this.validate(e);
    });
    _defineProperty(_assertThisInitialized(_this), "validate", function (e) {
      var _this$props$flowWebCo;
      if (!_this.formRef.current) {
        return;
      }
      var erroredField = _this.formRef.current.querySelector("[".concat(errorAttributeName, "=true]"));
      if (!erroredField) {
        _this.submit(e);
        return;
      }
      var fieldId = erroredField.getAttribute('id');
      if (fieldId) {
        erroredField = _this.formRef.current.querySelector("[for=\"".concat(fieldId, "\"]")) || erroredField;
      }
      var targetRect = erroredField.getBoundingClientRect();
      var offset = ((_this$props$flowWebCo = _this.props.flowWebConfig) === null || _this$props$flowWebCo === void 0 ? void 0 : _this$props$flowWebCo.scrollOffset) || 0;
      if (targetRect.top < offset) {
        erroredField.scrollIntoView();
        if (offset) {
          window.scrollTo(0, window.pageYOffset - offset);
        }
      }
      _this.setState({
        forceShowValidation: true,
        active: false
      });
    });
    return _this;
  }
  _createClass(_FormWithValidation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        flowWebConfig = _this$props.flowWebConfig,
        formProps = _objectWithoutProperties(_this$props, ["flowWebConfig"]);
      return /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: _objectSpread(_objectSpread({}, this.state), {}, {
          registerValidator: this.registerValidator,
          unregisterValidator: this.unregisterValidator,
          isForm: true
        })
      }, /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
        ref: this.formRef,
        onSubmit: this.onSubmit
      })));
    }
  }, {
    key: "submit",
    value: function submit(e) {
      var _this2 = this;
      if (!this.props.onSubmit) {
        return;
      }
      this.props.onSubmit(e).then(function () {
        _this2.setState({
          forceShowValidation: false,
          active: false
        });
      })["catch"](function () {
        _this2.setState({
          active: false
        });
      });
    }
  }]);
  return _FormWithValidation;
}(React.Component);

/**
 * The FormWithValidation component renders a <form> element, sets up a validation
 * context for all child form fields, and manages validation and loading states for
 * the form as a whole.
 *
 * When fields are invalid, form submission attempts are blocked and the onSubmit
 * prop is not called. If this behavior is not desired, use the simpler `Form` component
 * instead.
 */
export var FormWithValidation = withFlowWebContext(_FormWithValidation);
export function formErrorAttribute(isErrored) {
  return _defineProperty({}, errorAttributeName, isErrored);
}
export function withFormContext(Component) {
  var WithContext = function WithContext(props) {
    return /*#__PURE__*/React.createElement(FormContext.Consumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, context));
    });
  };
  return WithContext;
}